import { Controller } from "@hotwired/stimulus"
import PhotoSwipe from "photoswipe"
import Swiper from "swiper"
import { A11y, Autoplay } from "swiper/modules"

export default class extends Controller {
  static targets = ["carousel"]

  connect() {
    this.dataSources = new Map(this.carouselTargets.map((carousel) => [
      carousel,
      this.buildDataSource(carousel)
    ]))
    this.openLightbox = this.openLightbox.bind(this)
    this.pauseCarousel = this.pauseCarousel.bind(this)
    this.resumeCarousel = this.resumeCarousel.bind(this)

    this.carouselTargets.forEach((carousel) => {
      carousel.addEventListener("click", this.openLightbox)
      carousel.addEventListener("pointerenter", this.pauseCarousel)
      carousel.addEventListener("pointerleave", this.resumeCarousel)
    })

    this.swipers = this.carouselTargets.map((carousel) => new Swiper(carousel, {
      modules: [A11y, Autoplay],
      a11y: {
        enabled: true
      },
      autoplay: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? false : {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: carousel.dataset.panelsDirection === "reverse"
      },
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 24,
      speed: 18000
    }))
  }

  disconnect() {
    this.carouselTargets.forEach((carousel) => {
      carousel.removeEventListener("click", this.openLightbox)
      carousel.removeEventListener("pointerenter", this.pauseCarousel)
      carousel.removeEventListener("pointerleave", this.resumeCarousel)
    })
    this.swipers?.forEach((swiper) => swiper.destroy(true, true))
    this.lightbox?.destroy()
    this.dataSources = null
    this.lightbox = null
    this.swipers = null
  }

  buildDataSource(carousel) {
    return Array.from(carousel.querySelectorAll(".panels-button")).map((link) => ({
      height: Number(link.dataset.pswpHeight),
      src: link.href,
      width: Number(link.dataset.pswpWidth)
    }))
  }

  openLightbox(event) {
    const link = event.target.closest("a.panels-button")
    if (!link || !this.element.contains(link)) return

    event.preventDefault()
    const carousel = link.closest("[data-panels-target='carousel']")
    this.lightbox?.destroy()
    this.lightbox = new PhotoSwipe({
      dataSource: this.dataSources.get(carousel),
      index: Number(link.dataset.pswpIndex)
    })
    this.lightbox.init()
  }

  pauseCarousel(event) {
    const swiper = event.currentTarget.swiper
    if (!swiper?.autoplay.running) return

    const translate = swiper.getTranslate()
    swiper.autoplay.stop()
    swiper.setTransition(0)
    swiper.setTranslate(translate)
    swiper.updateActiveIndex()
    swiper.updateSlidesClasses()
    swiper.animating = false
  }

  resumeCarousel(event) {
    const swiper = event.currentTarget.swiper
    if (!swiper?.autoplay.running) swiper?.autoplay.start()
  }
}
